import React from 'react'
import useTopUserInfo from '../../../../hooks/useTopUserInfo'

import { topNumber } from '../../../../constants/activity-constants'
import useMediaQuery from '../../../../hooks/useMediaQuery'

import { DTO_TopUser } from '../../../../services/top-service'
import './top-players-table.scss'
import { useIsDomContentVisible } from '../../../../hooks/useIsDomContentVisible'

export default function TopPlayersTable() {
  const isMobile = useMediaQuery()
  const userTop = useTopUserInfo()
  const viewportVisible = useIsDomContentVisible('.f-top-players-table')

  const maxTop = 5
  const list = userTop.toplist.slice(0, 5)
  const emptyList: DTO_TopUser[] = new Array(
    Math.max(0, maxTop - list.length)
  ).fill({
    ...{
      name: '',
      email: '',
      point: 0,
    },
  })
  const cols = isMobile ? ['TOP'] : ['TOP', 'NOMBRE', 'CORREO']
  const rows = list.concat(emptyList).map((user: DTO_TopUser, idx:number) => {
    let top = idx + 1
    if (isMobile) {
      return (
        <tr key={idx}>
          <td>
            {user.name ? (
              <>
                <p>
                  <b>{top}.</b> {user.name}
                </p>
                <p className="ellipsis-break">{' ' + user.email}</p>
              </>
            ) : (
              ''
            )}
          </td>
        </tr>
      )
    }
    return (
      <tr key={idx}>
        <td>{user.name ? top : ''}</td>
        <td>{user.name}</td>
        <td>
          <p className="ellipsis-break">{user.email}</p>
        </td>
      </tr>
    )
  })
  return (
    <article className="f-top-players-table">
      <h3 className="title">Las mejores {maxTop} jugadoras están aquí</h3>
      <table className={` ${viewportVisible ? ' slide-in ' : ' slide-out '}`}>
        <thead>
          <tr>
            {cols.map((name, idx) => (
              <th key={idx + '_' + name}>{name}</th>
            ))}
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </article>
  )
}
